export enum AppErrors {
  ORGANIZATION_CONTEXT_MISSING_ORG = 'ORGANIZATION_CONTEXT_MISSING_ORG',
  REDIRECT_ON_WORKSPACE_SESSION_EXPIRY = 'REDIRECT_ON_WORKSPACE_SESSION_EXPIRY',
  CUSTOMER_PORTAL_SESSION_EXPIRED = 'CUSTOMER_PORTAL_SESSION_EXPIRED',
  CUSTOMER_PORTAL_REQUEST_FAILED = 'CUSTOMER_PORTAL_REQUEST_FAILED',
  INVALID_PORTAL_CUSTOMISATION_CONFIG = 'INVALID_PORTAL_CUSTOMISATION_CONFIG',
  FAILED_TO_LOAD_SOCIAL_CONNCETION = 'FAILED_TO_LOAD_SOCIAL_CONNCETION',
  FAILED_TO_LOAD_FEATURE_FLAG = 'FAILED_TO_LOAD_FEATURE_FLAG',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  TOKEN_EXCHANGE_FAILED = 'TOKEN_EXCHANGE_FAILED',
  LINK_EXPIRED = 'LINK_EXPIRED',
  INVALID_PORTAL_TYPE_IN_URL = 'INVALID_PORTAL_TYPE_IN_URL',
  RESOURCE_ALREADY_EXISTS = 'RESOURCE_ALREADY_EXISTS',
  NO_CLIENT_FOUND = 'NO_CLIENT_FOUND',
  FAILED_TO_GENERATE_SECRET = 'FAILED_TO_GENERATE_SECRET',
  TEST_ORG_NOT_FOUND = 'TEST_ORG_NOT_FOUND',
  CNAME_VALIDATION_FAILED = 'CNAME_VALIDATION_FAILED',
  CAA_VALIDATION_FAILED = 'CAA_VALIDATION_FAILED',
  FAIELD_TO_LOAD_CUSTOMIZATION_CONTEXT = 'FAIELD_TO_LOAD_CUSTOMIZATION_CONTEXT',
  NO_EMAIL_PROVIDED_FOR_DISCOVERY = 'NO_EMAIL_PROVIDED_FOR_DISCOVERY',
  NO_AUTH_METHOD_DISCOVRED_TO_LOGIN = 'NO_AUTH_METHOD_DISCOVRED_TO_LOGIN',
  FAILED_TO_RESEND_PASSWORDLESS_EMAIL = 'FAILED_TO_RESEND_PASSWORDLESS_EMAIL',
  INVALID_AUTH_REQUEST = 'INVALID_AUTH_REQUEST',
  NO_VALID_AUTH_REQUEST = 'NO_VALID_AUTH_REQUEST',
  ERROR_EMAIL_SERVER_INVALID = 'ERROR_EMAIL_SERVER_INVALID',
  LOGIN_BOX_INVALID_OTP = 'INVALID_CODE',
  INVALID_PARAM_CONNECTION_ID = 'INVALID_PARAM_CONNECTION_ID',
  RESTRICTED_CONNECTION_NAME = 'RESTRICTED_CONNECTION_NAME',
  CONNECTED_APP_PROVIDER_LIST_EMPTY = 'CONNECTED_APP_PROVIDER_LIST_EMPTY',
  CONNECTED_APP_PROVIDER_NOT_FOUND = 'CONNECTED_APP_PROVIDER_NOT_FOUND',
  INVALID_REDIRECT_URI = 'INVALID_REDIRECT_URI',
  CONNECTION_NOT_ENABLED = 'CONNECTION_NOT_ENABLED',
  TOOL_ERROR = 'TOOL_ERROR',
  DISPOSABLE_OR_PUBLIC_EMAIL = 'DISPOSABLE_OR_PUBLIC_EMAIL',
  INVALID_DOMAIN = 'INVALID_DOMAIN',
  FSA_NOT_ENABLED = 'FSA_NOT_ENABLED',
  CONNECTION_ACCOUNT_EXISTS_FOR_CONNECTION = 'CONNECTION_ACCOUNT_EXISTS_FOR_CONNECTION',
  STATIC_CONNECTED_ACCOUNT_CREATION_ABORTED = 'STATIC_CONNECTED_ACCOUNT_CREATION_ABORTED',
  OAUTH_CONNECTED_ACCOUNT_CREATION_ABORTED = 'OAUTH_CONNECTED_ACCOUNT_CREATION_ABORTED',
  MCP_SERVER_EXISTS_FOR_CONNECTED_ACCOUNT = 'MCP_SERVER_EXISTS_FOR_CONNECTED_ACCOUNT',
  ONLY_ONE_USER_EXISTS = 'ONLY_ONE_USER_EXISTS',
  DEFAULT_ROLE_NOT_FOUND = 'DEFAULT_ROLE_NOT_FOUND',
  LOGIN_INITIATION_URI_NOT_CONFIGURED = 'LOGIN_INITIATION_URI_NOT_CONFIGURED',
  FEATURE_NOT_ENABLED = 'FEATURE_NOT_ENABLED',
  PUBLIC_EMAIL_INVITE = 'PUBLIC_EMAIL_INVITE',
  DISPOSABLE_EMAIL_INVITE = 'DISPOSABLE_EMAIL_INVITE',
  PUBLIC_EMAIL_SIGNUP = 'PUBLIC_EMAIL_SIGNUP',
  DISPOSABLE_EMAIL_SIGNUP = 'DISPOSABLE_EMAIL_SIGNUP',
  FAILED_TO_FETCH_BILLING_INFO = 'FAILED_TO_FETCH_BILLING_INFO',
  FAILED_TO_FETCH_BILLING_USAGE = 'FAILED_TO_FETCH_BILLING_USAGE',
  USER_INVITE_NOT_ALLOWED = 'USER_INVITE_NOT_ALLOWED',
  USER_INVITE_VALIDATION_FAILED = 'USER_INVITE_VALIDATION_FAILED',
  INVALID_INTERCEPTOR_API_URL = 'INVALID_INTERCEPTOR_API_URL',
  INTERCEPTOR_TRIGGER_POINT_ALREADY_EXISTS = 'INTERCEPTOR_TRIGGER_POINT_ALREADY_EXISTS',
  RESPONSE_DECODE_FAILED = 'RESPONSE_DECODE_FAILED',
  RESPONSE_READ_FAILED = 'RESPONSE_READ_FAILED',
  HTTP_REQUEST_FAILED = 'HTTP_REQUEST_FAILED',
  AUTH_FAILED = 'AUTH_FAILED',
  HMAC_FAILED = 'HMAC_FAILED',
  HTTP_NON_OK_RESPONSE = 'HTTP_NON_OK_RESPONSE',
  HTTP_CLIENT_ERROR = 'HTTP_CLIENT_ERROR',
  HTTP_SERVER_ERROR = 'HTTP_SERVER_ERROR',
  HTTP_REQUEST_TIMEOUT = 'HTTP_REQUEST_TIMEOUT',
  INVALID_INTERCEPTOR_RESPONSE = 'INVALID_INTERCEPTOR_RESPONSE',
  ENV_PAGES_UNAUTHORIZED = 'ENV_PAGES_UNAUTHORIZED',
  INVALID_REQUEST = 'INVALID_REQUEST',
  NO_AVAILABLE_CONNECTIONS = 'NO_AVAILABLE_CONNECTIONS',
  MAX_POLLING_ATTEMPTS_REACHED = 'MAX_POLLING_ATTEMPTS_REACHED',
  MAX_ALLOWED_USERS_LIMIT_REACHED = 'MAX_ALLOWED_USERS_LIMIT_REACHED',
  FSA_ONBOARDING_WARNING_CANCELLED = 'FSA_ONBOARDING_WARNING_CANCELLED',
  INVALID_RESOURCE_URI = 'INVALID_RESOURCE_URI',
  ENV_APP_MISSING_SESSION_DETAILS = 'ENV_APP_MISSING_SESSION_DETAILS',
  ENV_APP_UNRESOLVED_ORGANIZATION = 'ENV_APP_UNRESOLVED_ORGANIZATION',
  ENV_APP_USER_NOT_FOUND = 'ENV_APP_USER_NOT_FOUND',
  ENV_APP_FORBIDDEN_USER = 'ENV_APP_FORBIDDEN_USER',
  AGENT_PORTAL_SESSION_EXPIRED = 'AGENT_PORTAL_SESSION_EXPIRED'
}

export enum AppErrorScopes {
  LOGIN = 'LOGIN',
  SIGNUP = 'SIGNUP',
  CLIENT_PORTAL = 'PORTAL_CLIENT',
  DASHBOARD_PORTAL = 'PORTAL_DASHBOARD'
}

export const mergeEmailParts = (emailParts: Array<string>) =>
  emailParts.join('@');
